import React from 'react'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'

const AmortizationPageUI = ({ context, errorList, account, loan, schedule, response, onRefreshClick,
}) =>
  <SuperUserLoanPageUI context={context} className='pg_su_amrt_lst' topnav='loans'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList || !account} loan={loan} page='amortization'
  >
    {
      (!loan || !errorList || !account) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      account && loan &&
      <div> 
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Amortization Schedule</b></span>
            </span>
          }
          right={<span />}
        />

        {
          loan.termSheet.amountF2 && response &&
          <AmortizationUI
            context={context}
            schedule={schedule} response={response}
          />
        }

        {
          !loan.termSheet.amountF2 && !loan.sanction.amountF2 &&
          <div className='g_m_left_100'>No amortization yet</div>
        }
      </div>
    }
  </SuperUserLoanPageUI>

const AmortizationUI = ({ schedule, response }) =>
  <div className='su_amrt'>
    {
      schedule &&
      <>
        <div className='g_m_bottom_100'>Amortization does not apply to lease transactions</div>
        <table><tbody>
          <tr>
            <td className='g_text_center'><b>Month</b></td>
            <td className='g_text_center g_m_left_100'><b className='g_m_left_100'>Interest</b></td>
            <td className='g_text_center g_m_left_100'><b className='g_m_left_100'>Principal</b></td>
            <td className='g_text_center g_m_left_100'><b className='g_m_left_100'>EMI</b></td>
            <td className='g_text_center g_m_left_100'><b className='g_m_left_100'>Balance</b></td>
          </tr>
          {
            schedule.map((monthly, i) =>
              <tr key={i}>
                <td className='g_text_center'><span>{monthly.month}</span></td>
                <td className='g_text_right'><span className='g_m_left_100'>{monthly.interestF5}</span></td>
                <td className='g_text_right'><span className='g_m_left_100'>{monthly.principalF5}</span></td>
                <td className='g_text_right'><span className='g_m_left_100'>{monthly.emiF5}</span></td>
                <td className='g_text_right'><span className='g_m_left_100'>{monthly.balanceF5}</span></td>
              </tr>
            )
          }
           <tr>
            <td className='g_text_center'><b>Totals</b></td>
            <td className='g_text_center g_m_left_100'><b className='g_m_left_100'>{response.totalInterestF5}</b></td>
            <td className='g_text_center g_m_left_100'><b className='g_m_left_100'>{response.totalPrincipalF5}</b></td>
            <td className='g_text_center g_m_left_100'><b className='g_m_left_100'>{response.totalEmiF5}</b></td>
          </tr>
       </tbody></table>
      </>
    }
  </div>

export default AmortizationPageUI
